/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link, useLocation, useNavigate} from 'react-router-dom'
import {useFormik} from 'formik'
import {login} from '../core/_requests'
import {useAuth} from '../core/Auth'
import {app_id} from '../../config'
import {useAppDispatch} from '../../../hook'
import {isReddata} from '../../../utils/helperFunction/_helper'

const loginSchema = Yup.object().shape({
  email: Yup.string().required('User Name is required'),
  password: Yup.string().max(50, 'Maximum 50 symbols').required('Password is required'),
  // isCaptcha: Yup.boolean().oneOf([true], 'Captcha is required'),
})

const initialValues = {
  email: '',
  password: '',
  isCaptcha: false,
  captchaToken: '',
}

export function Login() {
  const navigate = useNavigate()
  const location = useLocation()
  const {saveAuth, setCurrentUser, setUserAttachments} = useAuth()
  const dispatch = useAppDispatch()

  const [loading, setLoading] = useState(false)
  const [loginError, setLoginError] = useState(false)

  const dashboardUrl = '/analyze/dashboard'

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        // console.log(values)

        const data = await login(values.email, values.password)
        if (data?.data) {
          const auth = data.data
          saveAuth({
            accessToken: auth.token,
            username: auth.username,
            roles: auth.roles,
          })
          // Redirect to stored location or default to dashboard
          const redirectTo = location.state?.from || dashboardUrl
          // console.log(redirectTo)
          navigate(redirectTo, {replace: true})
        } else {
          setLoginError(true)
          setLoading(false)
        }
      } catch (error) {
        saveAuth(undefined)
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  const onHandleCaptcha = (token: string) => {
    formik.setFieldValue('captchaToken', token)
    formik.setFieldValue('isCaptcha', true)
  }

  return (
    <form
      className='form w-400px'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      {/* begin::Heading */}
      {app_id !== 3 ? (
        <div className='text-center mb-11'>
          <h1 className='text-dark fw-bolder mb-3'>Sign In</h1>
          {/* <div className='text-gray-500 fw-semibold fs-6'>Your Social Campaigns</div> */}
        </div>
      ) : null}
      {/* begin::Heading */}

      {/* <GoogleLogin onSuccess={responseMessage} onError={errorMessage} /> */}

      {/* begin::Login options */}
      <div className='row g-3 mb-9'>
        {/* begin::Col */}
        <div className='col-md-12'>
          {/* begin::Google link */}
          {/* {app_id !== 3 ? (
            <a
              href='#'
              className='btn btn-flex btn-outline btn-text-gray-700 btn-active-color-primary bg-state-light flex-center text-nowrap w-100'
            >
              <img
                alt='Logo'
                src={toAbsoluteUrl('/media/svg/brand-logos/google-icon.svg')}
                className='h-15px me-3'
              />
              Sign in with Google
            </a>
          ) : null} */}
          {/* end::Google link */}
        </div>
        {/* end::Col */}
      </div>
      {/* end::Login options */}

      {/* begin::Separator */}
      {/* {app_id !== 3 ? (
        <div className='separator separator-content my-14'>
          <span className='w-125px text-gray-500 fw-semibold fs-7'>Or with email</span>
        </div>
      ) : null} */}
      {/* end::Separator */}

      {/* begin::Form group */}
      <div className='fv-row mb-8'>
        <label className='form-label fs-6 fw-bolder text-dark'>User Name</label>
        <input
          placeholder='User Name'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control bg-transparent custom-input',
            {'is-invalid': formik.touched.email && formik.errors.email},
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            }
          )}
          type='text'
          name='email'
          autoComplete='off'
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.email}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='fv-row mb-8'>
        <label className='form-label fw-bolder text-dark fs-6'>Password</label>
        <input
          type='password'
          autoComplete='off'
          {...formik.getFieldProps('password')}
          className={clsx(
            'form-control bg-transparent custom-input',
            {
              'is-invalid': formik.touched.password && formik.errors.password,
            },
            {
              'is-valid': formik.touched.password && !formik.errors.password,
            }
          )}
        />
        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Wrapper */}
      {loginError ? <h6 className='text-danger'>Authentication Failed</h6> : ''}

      {/* <div className='mb-8'>
        <ReCAPTCHA
          sitekey='6LdeBPIqAAAAAApoXEDp1suN75P8cwyw9jZi0Pjh'
          // theme="dark"
          onChange={(token: string | null) => onHandleCaptcha(token)}
        />

        {formik.touched.isCaptcha && formik.errors.isCaptcha && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.isCaptcha}</span>
            </div>
          </div>
        )}
      </div> */}

      {/* <HCaptchaComponent siteKey={siteKey} onVerify={onHandleCaptcha} />

      {formik.touched.isCaptcha && formik.errors.isCaptcha && (
        <div className='fv-plugins-message-container text-end'>
          <div className='fv-help-block'>
            <span role='alert'>{formik.errors.isCaptcha}</span>
          </div>
        </div>
      )} */}

      <div className='text-end fs-base fw-semibold mb-8 mt-3'>
        {/* begin::Link */}
        <Link to='/auth/forgot-password' className='link-primary'>
          Forgot Password ?
        </Link>
        {/* end::Link */}
      </div>
      {/* end::Wrapper */}

      {/* begin::Action */}
      <div className='d-grid mb-10'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-primary'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && <span className='indicator-label'>Login</span>}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
      {/* end::Action */}

      <div className='text-end fs-5 fw-semibold'>
        {/* begin::Link */}
        {!isReddata() ? (
          <a href='https://iatlbd.com' target='_blank' className='text-primary'>
            Powered By IAT
          </a>
        ) : null}

        {/* end::Link */}
      </div>

      {/* {app_id !== 3 ? (
        <div className='text-gray-500 text-center fw-semibold fs-6'>
          Not a Member yet?{' '}
          <Link to='/auth/registration-number' className='link-primary'>
            Sign up
          </Link>
        </div>
      ) : null} */}
    </form>
  )
}
